import { Form, Button, Icon, notification, Card } from "antd";
import React, { Component } from "react";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request, { LAPI_URL } from "../../../request";
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
let isModal = false;
@Form.create()
class FinanceSetup extends Component {
    state = {
        loading: false,
        commSettings: {},
        cardLoading: false,
        bankArr: [],
    }


    onPrev = () => {
        this.props.onPrev();
    }


    handleFormSubmit = (e) => {
        e.preventDefault();
        let { form, onNext, isModal } = this.props;
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                values.businessId = activeUser.businessId;
                this.setState({ loadig: true });
                let response = await Request.addCommunicationSettings(values);
                this.setState({ loadig: false });
                if (response && response.success) {
                    notification.success({
                        message: response.message
                    })
                    if (onNext && isModal) {
                        onNext();
                    }
                } else {
                    notification.error({
                        message: response.message
                    })
                }
            }
        })
    }

    loadInitialData = async () => {
        this.setState({ cardLoading: true });
        let res = await Request.getCommunicationSettings();
        this.setState({ cardLoading: false });
        if (res && !res.error && res.doc) {
            this.props.form.setFieldsValue(res.doc);
            this.setState({
                commSettings: res.doc,
            });
        }
    }


    componentDidMount() {
        isModal = this.props.isModal;
        this.loadInitialData()
    }

    render() {
        let { form: { setFieldsValue, getFieldDecorator }, isModal } = this.props;
        let { loading, cardLoading } = this.state;
        let inputTypes = {
            fields: [
                {
                    label: 'Performa Invoice Prefix',
                    key: 'performaInvoiceNumberPrefix',
                    required: !isModal
                },
                {
                    label: 'Final Invoice Prefix',
                    key: 'invoiceNumberPrefix',
                    required: !isModal
                },
                {
                    label: 'Final Invoice Number Start Value',
                    key: 'finalInvoiceNumberStart',
                    required: !isModal
                },
                {
                    label: 'Finance Email',
                    key: 'financeEmail',
                    required: !isModal,
                    onBlur: (e) => {
                        const email = e.target.value;

                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                        if (!emailRegex.test(email)) {
                            notification.error({
                                message: 'Please Enter Valid Finance Email Address'
                            })
                            // show error (toast / set state / message)
                        } else {
                            // console.log('Valid email');
                        }
                    }
                },
                {
                    label: 'Corporate Office Address',
                    key: 'corporateOffice',
                    type: 'editor'
                },
                {
                    label: 'Registered Office Address',
                    key: 'registeredOffice',
                    type: 'editor'
                },
                {
                    label: 'Sign With Stamp',
                    key: 'signWithStamp',
                    type: 'file'
                },
                {
                    label: 'Invoice Header',
                    key: 'headerLogo',
                    type: 'file'
                },
                {
                    label: 'Invoice Footer',
                    key: 'footerLogo',
                    type: 'file'
                }
            ]
        }
        return (
            <Card loading={cardLoading}>
                <Form onSubmit={(e) => this.handleFormSubmit(e)}>
                    <GetAllFormFields apiurl={LAPI_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                    <div style={{ marginTop: 30, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                        {isModal && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}

                        <Button type="primary" htmlType="submit" loading={loading} style={{ height: 40, width: 140 }}>{isModal ? <span> NEXT STEP <Icon type="arrow-right" /></span> : 'SAVE'}</Button>
                    </div>
                </Form>
            </Card>
        )

    }
}



export default FinanceSetup;